import React from "react";
import history from "../utils/history";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { onError } = this.props;

    if (onError && typeof onError === "function") {
      // Error callback provided so invoke, and clear error to ensure children rendered
      try {
        onError();
        this.setState({ hasError: false });
      } catch (ignoredError) {}
      return;
    }
  }

  redirectProvided(redirectRoute) {
    return redirectRoute && redirectRoute.length > 0;
  }

  render() {
    const { children, fallback, redirectTo } = this.props;

    if (this.state.hasError) {
      if (fallback) {
        // Fallback provided so defer rendered output to supplied component/logic
        return typeof fallback === "function"
          ? fallback()
          : React.createElement(fallback);
      }

      if (this.redirectProvided(redirectTo)) {
        // Redirect provided redirect to supplied route
        history.push(redirectTo);
      } else {
        // No fallback or redirect provided so render default UI
        return <h1>An unhandled error was detected.</h1>;
      }
    }

    return children || null;
  }
}

export default ErrorBoundary;
